import React from 'react';
import { useTranslation } from 'react-i18next';

/** A phone number as a dialable tel: URI (spaces, dots and dashes removed). */
export const telHref = (phone) => `tel:${(phone || '').replace(/[^\d+]/g, '')}`;

/**
 * The phones of an appointment, as links that dial on a phone: the
 * intervention's contact number first (named after the person on site), then
 * the billing client; a legacy on-site client record when there is no
 * contact number.
 */
export default function AppointmentPhones({ appt, className = '' }) {
  const { t } = useTranslation();
  const parties = [];
  const contact = (appt.contact_phone || '').trim();
  const billing = appt.requesting_company;
  const onSite = appt.customer;
  if (contact) parties.push({ id: 'contact', name: appt.contact_name || t('appointments.contactShort'), phone: contact });
  if (billing && billing.phone && (!onSite || billing.id !== onSite.id)) parties.push(billing);
  if (onSite && onSite.phone && !contact) parties.push(onSite);
  if (!parties.length) return null;
  return (
    <span className={`appt-phones ${className}`.trim()}>
      {parties.map((p) => (
        <a key={p.id} href={telHref(p.phone)} onClick={(e) => e.stopPropagation()}>
          <span aria-hidden="true">✆ </span>{p.name} · {p.phone}
        </a>
      ))}
    </span>
  );
}
